//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { IDataTypePanelRule, IMRDataTypePanelFormItemOptions, IMRDataTypePanelAdditionalOptions } from '../interfaces'

import { Enums } from "../../../../models/common"
import { OpDataType } from "../../../../models/core"

import { LocalizationHelper } from "../../../../helpers"


export class DataTypeClassRealRule implements IDataTypePanelRule {

    private static get dataTypeClass(): number { return Enums.DataTypeClass.Real }


    //#region IDataTypePanelRule Implementation

    public canHandle(opDataType: OpDataType): JQueryPromise<boolean> {
        return $.Deferred<boolean>()
            .resolve(opDataType != null && opDataType.idDataTypeClass === DataTypeClassRealRule.dataTypeClass)
            .promise()
    }

    public getItemFormFieldOptions(opDataType: OpDataType, additionalOptions?: IMRDataTypePanelAdditionalOptions, isRequired?: boolean, data?: any[]): JQueryPromise<IMRDataTypePanelFormItemOptions> {
        if (opDataType != null) {
            const item: IMRDataTypePanelFormItemOptions = {
                dataField: opDataType.idDataType.toString(),
                editorType: 'dxNumberBox',
                validationRules: this.getDataTypeRuleOptions(opDataType, isRequired),

                editorOptions: {
                    value: _.first(data),
                },

                label: {
                    location: 'top',
                    text: opDataType.toString()
                },
            }

            return $.Deferred().resolve(item).promise()
        }

        return $.Deferred().resolve(null).promise()
    }

    //#endregion


    //#region Private Methods

    private getDataTypeRuleOptions(opDataType: OpDataType, isRequired: boolean = false): any[] {
        const validationRules: any[] = []

        if (opDataType.dataTypeFormat != null) {

            validationRules.push({
                type: 'numeric',
                message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NumericField)
            })

            if (opDataType.dataTypeFormat.numberMaxValue) {
                validationRules.push({
                    type: 'range',
                    max: opDataType.dataTypeFormat.numberMaxValue,
                    message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NumberMaxValue) + ' ' + opDataType.dataTypeFormat.numberMaxValue
                })
            }

            if (opDataType.dataTypeFormat.numberMinValue) {
                validationRules.push({
                    type: 'range',
                    min: opDataType.dataTypeFormat.numberMinValue,
                    message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NumberMinValue) + ' ' + opDataType.dataTypeFormat.numberMinValue
                })
            }

            if (opDataType.dataTypeFormat.numberMinPrecision && opDataType.dataTypeFormat.numberMaxPrecision) {
                validationRules.push({
                    type: 'pattern',
                    pattern: '^\\d+\\.\\d{' + opDataType.dataTypeFormat.numberMinPrecision + ',' + opDataType.dataTypeFormat.numberMaxPrecision + '}$',
                    message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NumberPrecisionRange) + ' ' + opDataType.dataTypeFormat.numberMinPrecision + '-' + opDataType.dataTypeFormat.numberMaxPrecision
                })
            } else if (opDataType.dataTypeFormat.numberMaxPrecision) {
                validationRules.push({
                    type: 'pattern',
                    pattern: '^\\d+(\\.\\d{1,' + opDataType.dataTypeFormat.numberMaxPrecision + '})?$',
                    message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NumberMaxPrecision) + ' ' + opDataType.dataTypeFormat.numberMaxPrecision
                })
            } else if (opDataType.dataTypeFormat.numberMinPrecision) {
                validationRules.push({
                    type: 'pattern',
                    pattern: '^\\d+\\.\\d{' + opDataType.dataTypeFormat.numberMinPrecision + ',}$',
                    message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NumberMinPrecision) + ' ' + opDataType.dataTypeFormat.numberMinPrecision
                })
            }
        }

        if (isRequired) {
            validationRules.push({
                type: 'required',
                message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
            })
        }

        return validationRules
    }

    //#endregion

}